<template>
    <div class="main main-padding">
        <!--基础数据-->
        <Row :gutter="10" style="margin-top: 20px;">
            <Col :xs="12" :sm="12" :md="8" :lg="6" :xl="4" class="screen-main-cards">
                <infor-card
                    id-name="installCount"
                    :end-val="baseData.installCount"
                    iconType="md-browsers"
                    color="#39C6E9"
                    textColor="#39C6E9"
                    intro-text="安装大屏的MAC数量"
                ></infor-card>
            </Col>
            <Col :xs="12" :sm="12" :md="8" :lg="6" :xl="4" class="screen-main-cards">
                <infor-card
                    id-name="screenSchoolCount"
                    :end-val="baseData.screenSchoolCount"
                    iconType="md-podium"
                    color="#39C6E9"
                    textColor="#39C6E9"
                    intro-text="大屏学校数量"
                ></infor-card>
            </Col>
            <Col :xs="12" :sm="12" :md="8" :lg="6" :xl="4" class="screen-main-cards">
                <infor-card
                    id-name="screenClassCount"
                    :end-val="baseData.screenClassCount"
                    iconType="ios-school"
                    color="#39C6E9"
                    textColor="#39C6E9"
                    intro-text="大屏班级数量"
                ></infor-card>
            </Col>
            <Col :xs="12" :sm="12" :md="8" :lg="6" :xl="4" class="screen-main-cards">
                <infor-card
                    id-name="totalScreenCount"
                    :end-val="baseData.totalScreenCount"
                    iconType="ios-desktop"
                    color="#39C6E9"
                    textColor="#39C6E9"
                    intro-text="大屏总用户数"
                ></infor-card>
            </Col>
        </Row>
        <!--  大屏日活用户趋势图 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <line-charts
                    :chartsTitle="'大屏日活用户趋势图'"
                    :chartsId="'screen_day_trend'"
                    :lineCompany="'人'"
                    ref="screenDayTrend"
                ></line-charts>
            </Col>
        </Row>
        <!-- 大屏每周使用人数、大屏每月使用人数-->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="12" :md="6" :lg="12" :xl="12">
                <line-charts
                    :chartsTitle="'大屏每周使用人数'"
                    :chartsId="'screen_weekly_num'"
                    :lineCompany="'人'"
                    ref="screenWeeklyNum"
                ></line-charts>
            </Col>
            <Col :xs="24" :sm="12" :md="6" :lg="12" :xl="12">
                <line-charts
                    :chartsTitle="'大屏每月使用人数'"
                    :chartsId="'screen_monthly_num'"
                    :lineCompany="'人'"
                    ref="screenMonthlyNum"
                ></line-charts>
            </Col>
        </Row>
        <!-- 大屏每月活跃百分比趋势 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <line-charts
                    :chartsTitle="'大屏每月活跃百分比趋势'"
                    :chartsId="'screen_month_percent'"
                    :lineCompany="'%'"
                    ref="screenMonthPercent"
                ></line-charts>
            </Col>
        </Row>
        <!-- 主要使用场景排序、大屏用户学科分析、大屏主要行为分布 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <pie-charts
                    :chartsTitle="'主要使用场景排序'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'screen_main_scene'"
                    :pieChartsName="'场景排序'"
                    ref="mainSceneSort"
                ></pie-charts>
            </Col>
            <Col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <div class="stage-select">
                    <RadioGroup v-model="subjectStage"  @on-change="changeStage(subjectStage)">
                        <Radio :label="item.value" v-for="(item,index) in stageList" :key="item.key"></Radio>
                    </RadioGroup>
                </div>
                <pie-charts
                    :chartsTitle="'大屏使用用户学科分析'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'screen_subject_analyse'"
                    :pieChartsName="'学科分析'"
                    ref="screenSubjectAnalyse"
                ></pie-charts>
            </Col>
        </Row>
        <!--  大屏用户操作次数 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <histogram-charts
                    :chartsTitle="'大屏用户操作次数'"
                    :isShowMore=false
                    :isClickCharts=false
                    :chartsId="'screen_user_operate'"
                    :height="'360px'"
                    :histogramTooltip="'useSecond'"
                    ref="screenUseOperation"
                ></histogram-charts>
            </Col>
        </Row>
        <!--  各校安装大屏数 -->
        <Row :gutter="10" style="margin-top: 10px;">
            <Col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <histogram-charts
                    :chartsTitle="'各校安装大屏数'"
                    :isShowMore=false
                    :isClickCharts=false
                    :isSchool=true
                    :chartsId="'screen_install_school'"
                    :height="'360px'"
                    :histogramTooltip="'install'"
                    ref="schoolInstallScreen"
                ></histogram-charts>
            </Col>
        </Row>
    </div>
</template>
<script>
    import inforCard from "../../../components/inforCard.vue";//数据卡片
    import HistogramCharts from "../../../components/charts/HistogramCharts.vue";//柱状图
    import PieCharts from "../../../components/charts/PieCharts.vue";//饼状图
    import LineCharts from "../../../components/charts/LineCharts.vue";//折线图
    import {
        findScreenUseNum,
        findScreenDayUseChar,
        findScreenWeeklyUseNum,
        findScreenMonthlyUseNum,
        findScreenMonthlyPercentage,
        findScreenSceneRanking,
        findScreenTopTwenty,
        findScreenSchoolUserNum,
        findScreenDisciplineAnaly
    } from "../../../service/api.js";

    export default {
        name: "screen-main",
        data () {
            return {
                baseData: {
                    installCount: 0,//安装大屏的MAC数量
                    screenSchoolCount: 0,//大屏学校数量
                    screenClassCount: 0,//大屏班级数量
                    totalScreenCount: 0//大屏总用户数
                },
                subjectStage:"小学",//学科使用统计默认学段
                subjectPhase:1,//默认为小学
                stageList:[
                    {
                        key:1,
                        value:'小学'
                    },
                    {
                        key:2,
                        value:'初中'
                    },
                    {
                        key:3,
                        value:'高中'
                    },
                ]
            };
        },
        components: {
            inforCard,//数据卡片
            HistogramCharts,//柱状图组件
            PieCharts,//饼图组件
            LineCharts//折线图
        },
        methods: {
            /**
             * 切换学段
             */
            changeStage(val){
                for(let i=0;i<this.stageList.length;i++){
                    if(this.stageList[i].value===val){
                        this.subjectPhase=this.stageList[i].key;
                    }
                }
                this.getScreenDisciplineAnaly();
            },
            /**
             * 获取安装大屏的mac数量、大屏学校数量、大屏班级数量、大屏总用户数数据
             */
            async getScreenUseNum () {
                let _this = this;
                await findScreenUseNum()
                    .then(function (data) {
                        _this.baseData.screenSchoolCount = data.shcoolCount;
                        _this.baseData.totalScreenCount = data.userCount;
                        _this.baseData.installCount = data.diskCount;
                        _this.baseData.screenClassCount = data.classCount;
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取大屏日活用户趋势图
             */
            async getScreenDayUseChar () {
                let _this = this;
                await findScreenDayUseChar()
                    .then(function (data) {
                        let userList = data;
                        let dateArr = [];
                        let numberArr = [];
                        for (let i = 0; i < userList.length; i++) {
                            dateArr.push(userList[i].date);
                            numberArr.push(userList[i].number);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.screenDayTrend.initDataSource(userList, dateArr, numberArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取大屏每周使用人数数据
             */
            async getScreenWeeklyUseNum () {
                let _this = this;
                await findScreenWeeklyUseNum()
                    .then(function (data) {
                        let weekList = data;
                        let dateArr = [];
                        let numberArr = [];
                        for (let i = 0; i < weekList.length; i++) {
                            let strWeekStr = weekList[i].dates.substring(5, 11);
                            let endWeekStr = weekList[i].dates.substring(16);
                            let weekStr = strWeekStr + endWeekStr;
                            dateArr.push(weekStr);
                            numberArr.push(weekList[i].number);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.screenWeeklyNum.initDataSource(weekList, dateArr, numberArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取大屏每月使用人数
             */
            async getScreenMonthlyUseNum () {
                let _this = this;
                await findScreenMonthlyUseNum()
                    .then(function (data) {
                        let monthList = data;
                        let dateArr = [];
                        let numberArr = [];
                        for (let i = 0; i < monthList.length; i++) {
                            dateArr.push(monthList[i].month);
                            numberArr.push(monthList[i].userCount);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.screenMonthlyNum.initDataSource(monthList, dateArr, numberArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取大屏每月活跃百分比趋势
             */
            async getScreenMonthlyPercentage () {
                let _this = this;
                await findScreenMonthlyPercentage()
                    .then(function (data) {
                        let perList = data;
                        let dateArr = [];
                        let numberArr = [];
                        for (let i = 0; i < perList.length; i++) {
                            dateArr.push(perList[i].month);
                            numberArr.push(perList[i].userCount);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.screenMonthPercent.initDataSource(perList, dateArr, numberArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取主要使用场景排序
             */
            async getScreenSceneRanking () {
                let _this = this;
                await findScreenSceneRanking()
                    .then(function (data) {
                        let sceneList = data;
                        let nameArr = [];
                        let dataArr = [];
                        for (let i = 0; i < sceneList.length; i++) {
                            let obj = {};
                            //处理数据用于渲染图表
                            obj.value = sceneList[i].userCount;
                            obj.name = sceneList[i].clsName;
                            dataArr.push(obj);
                            nameArr.push(sceneList[i].clsName);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.mainSceneSort.initDataSource(sceneList, nameArr, dataArr);
                        })

                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取大屏用户学科分析数据
             */
            async getScreenDisciplineAnaly () {
                let _this = this;
                let params={
                    phase: this.subjectPhase
                };
                await findScreenDisciplineAnaly(params)
                    .then(function (data) {
                        let subjectList = data;
                        let nameArr = [];
                        let dataArr = [];
                        for (let i = 0; i < subjectList.length; i++) {
                            let subObj = {};
                            subObj.value = subjectList[i].userCount;
                            subObj.name = subjectList[i].subName;
                            nameArr.push(subjectList[i].subName);
                            dataArr.push(subObj);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.screenSubjectAnalyse.initDataSource(subjectList, nameArr, dataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取大屏用户操作次数
             */
            async getScreenTopTwenty () {
                let _this = this;
                await findScreenTopTwenty()
                    .then(function (data) {
                        let operationList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        for (let i = 0; i < operationList.length; i++) {
                            xDataArr.push(operationList[i].fullName);
                            seriesDataArr.push(operationList[i].userCount);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.screenUseOperation.initDataSource(operationList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            },
            /**
             * 获取各校安装大屏数
             */
            async getScreenSchoolUserNum () {
                let _this = this;
                await findScreenSchoolUserNum()
                    .then(function (data) {
                        let schoolList = data;
                        let xDataArr = [];
                        let seriesDataArr = [];
                        for (let i = 0; i < schoolList.length; i++) {
                            xDataArr.push(schoolList[i].schoolName);
                            seriesDataArr.push(schoolList[i].userCount);
                        }
                        _this.$nextTick(() => {
                            //渲染图表
                            _this.$refs.schoolInstallScreen.initDataSource(schoolList, xDataArr, seriesDataArr);
                        })
                    })
                    .catch(function (error) {
                        _this.$Message.error(error.message);
                    });
            }
        },
        mounted () {
            this.$store.commit("SET_TOPHEADERNAME", "大屏产品使用统计");
            //获取安装大屏的mac数量、大屏学校数量、大屏班级数量、大屏总用户数数据
            this.getScreenUseNum();
            //获取大屏日活用户趋势图
            this.getScreenDayUseChar();
            //获取大屏每周使用人数
            this.getScreenWeeklyUseNum();
            //获取大屏每月使用人数
            this.getScreenMonthlyUseNum();
            //获取大屏每月活跃百分比趋势
            this.getScreenMonthlyPercentage();
            //获取主要场景排序
            this.getScreenSceneRanking();
            //获取大屏用户学科分析数据
            this.getScreenDisciplineAnaly();
            //获取大屏用户操作次数
            this.getScreenTopTwenty();
            //获取各校安装大屏数
            this.getScreenSchoolUserNum();
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../../style/home";
    /*.mian {*/
    /*margin: 0.5%;*/
    /*}*/
</style>

<style lang="scss">
    .screen-main-cards.screen-main-cards {
        width: 25%
    }
</style>

